import { render } from "./IziIcon.vue?vue&type=template&id=23547368"
import script from "./IziIcon.vue?vue&type=script&lang=ts"
export * from "./IziIcon.vue?vue&type=script&lang=ts"

import "./IziIcon.vue?vue&type=style&index=0&id=23547368&lang=scss"
script.render = render

export default script